<template>
  <button type="button" class="zoomable" :class="[modeClass, { 'is-inverted': invert }]" @click="open = true">
    <img :src="src" :alt="alt" />
    <span class="zoom-hint">点击放大</span>
  </button>

  <Teleport to="body">
    <div v-if="open" class="lightbox" @click.self="open = false">
      <div class="lightbox-panel">
        <button type="button" class="close-btn" @click="open = false">关闭</button>
        <div class="lightbox-title">{{ alt }}</div>
        <img class="lightbox-img" :class="{ 'is-inverted': invert }" :src="src" :alt="alt" />
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ZoomableImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'cover'
    },
    invert: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    modeClass() {
      return this.fit === 'contain' ? 'fit-contain' : 'fit-cover';
    }
  }
};
</script>

<style scoped>
.zoomable {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  overflow: hidden;
  cursor: zoom-in;
  font: inherit;
}

.zoomable img {
  width: 100%;
  height: 100%;
  display: block;
  transition: transform 0.25s ease;
}

.zoomable.fit-cover img {
  object-fit: cover;
}

.zoomable.fit-contain img {
  object-fit: contain;
  padding: 10px;
  background: #ffffff;
}

.zoomable.is-inverted img,
.lightbox-img.is-inverted {
  filter: invert(1);
}

.zoomable:hover img {
  transform: scale(1.035);
}

.zoom-hint {
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: rgba(255, 255, 255, 0.94);
  background: rgba(19, 32, 51, 0.68);
  backdrop-filter: blur(8px);
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 0.78rem;
  line-height: 1;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.zoomable:hover .zoom-hint {
  opacity: 1;
  transform: translateY(0);
}

.lightbox {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(5, 12, 24, 0.78);
}

.lightbox-panel {
  width: min(1120px, 96vw);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 18px;
  background: #0f172a;
  box-shadow: 0 28px 90px rgba(0, 0, 0, 0.48);
}

.close-btn {
  align-self: flex-end;
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.92);
  cursor: pointer;
}

.lightbox-title {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 800;
  letter-spacing: 1px;
}

.lightbox-img {
  width: 100%;
  max-height: 78vh;
  object-fit: contain;
  border-radius: 14px;
  background: #111827;
}

@media (max-width: 768px) {
  .zoom-hint {
    opacity: 1;
    transform: none;
  }
}
</style>
